:host {
  position: absolute;
  z-index: 9999;

  .loading-wrapper {
    position: relative;
    width: min-content !important;

    wc-select {
      opacity: 0;
    }

    &-skeleton {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      @include skeletonRipple;
    }
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 50%;
    z-index: 9998;
    pointer-events: auto;
    animation-name: backDropFadeIn;
    animation-duration: 0.4s;
    animation-iteration-count: 1;
    @keyframes backDropFadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 50%;
      }
    }
  }

  a:not([disabled]) {
    color: var(--settings-blue, #0098ff);
    &[href*='\#']:not([href$='\#']) {
      cursor: pointer;
    }
    outline: none !important;
    box-sizing: border-box;
  }

  a[disabled] {
    color: unset !important;
  }

  .modal-content {
    display: inline-block;
    text-align: left;
    white-space: normal;
    border-radius: 10px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.15);
    position: fixed;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    vertical-align: middle;
    overflow: hidden;
    z-index: 9999999;

    width: 1200px;
    height: 770px;
    max-height: 90%;

    @include lg {
      height: calc(100vh - 40px);
      width: calc(100vw - 40px);
      max-height: unset;
    }
    @include md {
      height: 100vh;
      width: 100vw;
      border-radius: 0;
      max-height: 100%;
    }

    @include sm {
      max-height: 100%;
    }
  }

  .settings {
    @media (display-mode: standalone) {
      padding-top: env(safe-area-inset-bottom, 0px);
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }

    box-sizing: border-box;
    display: flex;
    height: 100%;
    border-radius: 10px;
    background-color: var(--bg-settings-content);
  }
}
